export default __webpack_public_path__ + "static/media/recording-off-white.ae919624.svg";